import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getWebrtcPublicConfig,
  getWebrtcConfig,
  enableWebrtcOnExtension,
  IWebrtcPublicConfig,
  IWebrtcConfig,
} from "../../services/webrtc/webrtcApi";
import { ERROR_MESSAGES } from "../../constants/enums";

export const fetchWebrtcPublicConfig = createAsyncThunk<
  { data: IWebrtcPublicConfig },
  void,
  { rejectValue: { message: string; status?: number } }
>("webrtc/fetchPublicConfig", async (_, { rejectWithValue }) => {
  try {
    const data = await getWebrtcPublicConfig();
    return { data };
  } catch (err: any) {
    return rejectWithValue({
      message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
      status: err.response?.status,
    });
  }
});

export const fetchWebrtcConfig = createAsyncThunk<
  { data: IWebrtcConfig },
  string,
  { rejectValue: { message: string; status?: number } }
>("webrtc/fetchConfig", async (extensionNumber, { rejectWithValue }) => {
  try {
    const data = await getWebrtcConfig(extensionNumber);
    return { data };
  } catch (err: any) {
    const status = err.response?.status;
    const message = err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR;

    // Map errors per task 9
    let mappedMessage = message;
    if (status === 404) {
      mappedMessage = "Extension not found. Contact admin.";
    } else if (status === 409) {
      if (message.toLowerCase().includes("not a pjsip user")) {
        mappedMessage =
          "This extension is not compatible with the browser softphone (needs PJSIP).";
      } else if (message.toLowerCase().includes("does not have webrtc enabled")) {
        mappedMessage = "WebRTC isn't enabled on your extension.";
      }
    } else if (status === 500 || status === 502) {
      mappedMessage = "Phone service temporarily unavailable, please retry.";
    }

    return rejectWithValue({ message: mappedMessage, status });
  }
});

export const enableWebrtcExtension = createAsyncThunk<
  { message: string },
  number | string,
  { rejectValue: { message: string; status?: number } }
>("webrtc/enableExtension", async (extensionId, { rejectWithValue }) => {
  try {
    const result = await enableWebrtcOnExtension(extensionId);
    return { message: result.message };
  } catch (err: any) {
    return rejectWithValue({
      message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
      status: err.response?.status,
    });
  }
});
